import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import UserHomeView from '../views/UserHomeView.vue';  // 更新路径
import AiView from '../views/aichat/AiView.vue';  // 新路径
import LoginView from '../views/login/LoginView.vue';  // 新路径
import RegisterView from '../views/login/RegisterView.vue';  // 注册页面
import ProfileView from '../views/user/ProfileView.vue';  // 新路径
import PostListView from '../views/post/PostListView.vue';  // 帖子列表页面
import PostDetailView from '../views/post/PostDetailView.vue';  // 帖子详情页面
import ChatView from '../views/message/ChatView.vue';  // 消息中心页面
import AnnouncementCenterView from '../views/message/AnnouncementCenterView.vue';  // 公告中心页面
import NotificationCenterView from '../views/message/NotificationCenterView.vue';  // 通知中心页面

// 导入管理后台路由
import adminRoutes from '../../admin/router';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: UserHomeView  // 主页使用 UserHomeView
  },
  {
    path: '/post',
    name: 'postList',
    component: UserHomeView,  // 修改为 UserHomeView，这样就能保持导航栏
  },
  {
    path: '/post/:postId',
    name: 'postDetail',
    component: UserHomeView,  // 使用 UserHomeView 以保持导航栏
    props: true
  },
  {
    path: '/ai',
    name: 'ai',
    component: UserHomeView,  // 修改为 UserHomeView 以保持导航栏
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterView
  },
  {
    path: '/profile',
    name: 'profile',
    component: UserHomeView,  // 修改为 UserHomeView 以保持导航栏
  },
  {
    path: '/profile/:userId',
    name: 'user-detail',
    component: UserHomeView,  // 使用 UserHomeView 以保持导航栏
  },
  {
    path: '/user/friends',
    name: 'friends',
    component: UserHomeView,  // 使用 UserHomeView 以保持导航栏
  },
  {
    path: '/user/favorites',
    name: 'favorites',
    component: UserHomeView,  // 使用 UserHomeView 以保持导航栏
  },
  {
    path: '/user/posts',
    name: 'userPosts',
    component: UserHomeView,  // 使用 UserHomeView 以保持导航栏
  },
  {
    path: '/chat',
    name: 'chat',
    component: ChatView  // 消息中心页面
  },
  {
    path: '/announcements',
    name: 'announcements',
    component: UserHomeView,  // 使用 UserHomeView 以保持导航栏
    children: [
      {
        path: '', // 默认子路由
        name: 'announcements-default', // 添加名称以消除警告
        component: () => import('@/user/views/message/AnnouncementCenterView.vue')
      }
    ]
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: UserHomeView,  // 使用 UserHomeView 以保持导航栏
  },
  // 将管理后台路由添加到主路由中
  ...adminRoutes
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;